let searchButton = document.getElementById('searchButton')
let searchInput = document.getElementById('search-input')
searchButton.addEventListener("click", (event)=>{
    if(searchButton.getAttribute('aria-expanded') == "false"){
      searchButton.ariaExpanded = "true"
      searchInput.classList.add("is-active")
    } else {
      searchButton.ariaExpanded = "false"
      searchInput.classList.remove("is-active")
    }
  })


function toggleMenu(event){
  let navButtons = document.getElementsByClassName('menu-toggle');
  let button = event.srcElement
  let submenu = document.getElementById(button.getAttribute("aria-controls"))
  if(submenu.classList.contains('is-active')) {
    submenu.classList.remove('is-active')
    button.classList.remove('is-active')
    button.ariaExpanded = "false"
    closeAllSubmenus()
  } else {
    submenu.classList.add('is-active')
    button.ariaExpanded = "true"
    button.classList.add('is-active')
    closeSubmenusExcept(button.getAttribute("id"))
  }
}

function closeSubmenusExcept(filter){
  for(let i = 0; i < navButtons.length; i++){
    let button = navButtons.item(i)
    let submenu = document.getElementById(button.getAttribute("aria-controls"))
    if(button.getAttribute("id") != filter){
      submenu.classList.remove('is-active')
      button.classList.remove('is-active')
      button.ariaExpanded = "false"
    }
  }
}

function closeAllSubmenus(){
    closeSubmenusExcept("none")
}

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

let navButtons = document.getElementsByClassName('menu-toggle');
let submenus = document.getElementsByClassName("submenu")
for(let i=0; i < submenus.length; i++ ){
  submenus.item(i).addEventListener("mouseleave", closeAllSubmenus)
}
for(let i = 0; i < navButtons.length; i++){
  let button = navButtons.item(i)
  button.addEventListener("click", toggleMenu)
}

let tabletMenuToggle = document.getElementById("main-menu-toggle")
tabletMenuToggle.addEventListener("click", (event)=>{
    if(tabletMenuToggle.ariaExpanded == "false"){
      tabletMenuToggle.ariaExpanded = "true"
      tabletMenuToggle.classList.add('is-active')
      document.getElementById("main-menu").classList.add("is-active")
    } else {
      tabletMenuToggle.ariaExpanded = "false"
      tabletMenuToggle.classList.remove('is-active')
      document.getElementById("main-menu").classList.remove("is-active")
    }
})


$(window).on("load", function () {
  setLpBanner();

  if ($(".article-with-image").length > 0) {
    $(".article-with-image .right-slider").slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  if ($(".announcement-bar").length > 0) {
    $(".announcement-bar").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
    });
  }
 

});

//Jeffs code additions
$(function () {
  if($("#s-d1c027c6-8564-421e-bf68-ccaca24d360e").length > 0) {
    $("#s-d1c027c6-8564-421e-bf68-ccaca24d360e .shogun-accordion-heading").attr("tabindex", "0");
    $(document).on("keydown", "#s-d1c027c6-8564-421e-bf68-ccaca24d360e .shogun-accordion-heading", function(e){
      if(e.keyCode == 13) {
        $(this).trigger("click");
      }
    });
  }
  if($(".marquee-wrapper").length > 0) {
    $(".baby-top-banner-radius").append(`<button class="marquee-control play" title="Pause">Pause</button>`);
  }
  let yotpoInt = setInterval(()=> {
    if($(".yotpo-product-link")) {
      $(".yotpo-product-link").attr("tabindex","0");
      clearInterval(yotpoInt);
    }
  }, 300);
  $(".search-component.js-search-input").removeAttr("placeholder").attr("tabindex", "0").attr("aria-label", "Product Search");
  var a = document.getElementById("s-07ea4b3d-47a5-4b70-ae21-b6e8f09b9d70");
  var openGorgias = function () {
    var iframe = document.getElementById("chat-button");
    var g = iframe.contentWindow.document.querySelector(
      "#gorgias-chat-messenger-button"
    );
    g.click();

    a.addEventListener("click", openGorgias, false);
  };

  if ($(".review-box-slider").length > 0) {
    if ($(window).width() < 768) {
      $(".review-box-slider >.shg-row").slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  }

  if (
    $(".cell-salt-slider2").length > 0 &&
    $(".cell-salt-slider1").length > 0
  ) {
    $(".cell-salt-slider1 >.shg-row").append(
      $(".cell-salt-slider2 >.shg-row").html()
    );
    $(".cell-salt-slider2").remove();
    $(".cell-salt-slider >.shg-row").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  } else {
    if ($(".cell-salt-slider").length > 0) {
      $(".cell-salt-slider > .shg-row").slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }

  setLpBanner();
  if ($(".lp-banner-carousel").length > 0) {
    $(".lp-banner-carousel").slick({
      lazyLoad: "ondemand",
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      fade: true,
    });
  }

  if($(".dog-slider-columns .shg-sld-slides").length > 0) {
    $(".dog-slider-columns .shg-sld-slides").slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

    
});

function setLpBanner() {
  if ($(".lp-banner-carousel").length > 0) {
    $(".lp-banner-wrapper").css({ width: "auto" });
    let img_height = $(".banner-frame").height();
    /*if(img_height < 1000) {
      $(".lp-banner-wrapper").css({"width":img_height+"px"});
    }
    else {
      $(".lp-banner-wrapper").css({"width":"1000px", "height":"1000px"});
    }*/
    if ($(window).height() > $(window).width()) {
      let w = $(window).width() - 100;
      $(".banner-frame").css({
        width: w + "px",
        height: w + "px",
        "max-height": w + "px",
        "max-width": w + "px",
      });
      $(".lp-banner-wrapper").css({
        width: w + "px",
        height: w + "px",
        "max-width": w + "px",
      });
      //if($(".icon3").offset().left < 0) {
      let off_left = $(".icon3").offset().left * -1.5;
      let x = $(window).width() / 3.5;
      if ($(window).width() <= 1366) {
        x = $(window).width() / 6;
      }
      w = w - x;
      $(".banner-frame").css({
        width: w + "px",
        height: w + "px",
        "max-height": w + "px",
        "max-width": w + "px",
      });
      $(".lp-banner-wrapper").css({
        width: w + "px",
        height: w + "px",
        "max-width": w + "px",
      });
      //}
    } else {
      let w = $(window).width() - 200;
      $(".banner-frame").css({
        width: w + "px",
        height: w + "px",
        "max-height": w + "px",
        "max-width": w + "px",
      });
      $(".lp-banner-wrapper").css({
        width: w + "px",
        height: w + "px",
        "max-width": w + "px",
      });
      //if($(".icon3").offset().left < 0) {
      let off_left = $(".icon3").offset().left * -1.5;
      let x = $(window).width() / 3.5;
      if ($(window).width() <= 1366) {
        x = $(window).width() / 6;
      }
      w = w - x;
      $(".banner-frame").css({
        width: w + "px",
        height: w + "px",
        "max-height": w + "px",
        "max-width": w + "px",
      });
      $(".lp-banner-wrapper").css({
        width: w + "px",
        height: w + "px",
        "max-width": w + "px",
      });
      //}
    }
    if ($(window).width() < 768) {
      let w = $(window).width() - 80;
      $(".banner-frame").css({
        width: w + "px",
        height: w + "px",
        "max-height": w + "px",
        "max-width": w + "px",
      });
      $(".lp-banner-wrapper").css({
        width: w + "px",
        height: w + "px",
        "max-width": w + "px",
      });
    }
  }
}
$(document).on("click", ".marquee-control", function(){
  if($(this).hasClass("play")) {
    $(this).text("Play");
    $(this).toggleClass("play pause");
    $(".marquee-wrapper .marquee").addClass("paused");
    $(this).attr("Title", "Play");
  }
  else {
    $(this).text("Pause");
    $(this).toggleClass("play pause");
    $(".marquee-wrapper .marquee").removeClass("paused");
    $(this).attr("Title", "Pause");
  }
});
               
$(document).on("mouseenter", ".list-menu li[area-expanded='false']", function(){
  $(this).attr("area-expanded", "true");
});
$(document).on("mouseleave", ".list-menu li[area-expanded='true']", function(){
  $(this).attr("area-expanded", "false");
});
$(window).on("load scroll", function () {
  var scrolled = $(this).scrollTop();
  if ($(".img-parallax").length > 0) {
    $(".img-parallax")
      .not(".stop-animation")
      .css("transform", "translate3d(0, " + -(scrolled * 0.18) + "px, 0)"); // parallax (25% scroll rate)
    $(".img-parallax.stop-animation").css(
      "transform",
      "translate3d(0, " + -(scrolled * 1) + "px, 0)"
    ); // parallax (25% scroll rate)
    var wh = $(this).height() + 0;
    /*$('.toon').each(function(){
    if($(this).is(":in-viewport("+(0)+")")) {
      $(this).css('transform', 'translate3d(0, ' + (scrolled * 0.18) + 'px, 0)'); // parallax (25% scroll rate)
    }
    });*/
    if ($(".toon-1").is(":in-viewport")) {
      $(".toon-1").css(
        "transform",
        "translate3d(0, " + scrolled * 0.18 + "px, 0)"
      ); // parallax (25% scroll rate)
    }
    if ($(".toon-2").is(":in-viewport")) {
      $(".toon-2")
        .not(".stop-animation")
        .css("transform", "translate3d(0, " + scrolled * 0.18 + "px, 0)"); // parallax (25% scroll rate)
    }
    if ($(".toon-3").is(":in-viewport")) {
      $(".toon-3")
        .not(".stop-animation")
        .css("transform", "translate3d(0, " + scrolled * 0.12 + "px, 0)"); // parallax (25% scroll rate)
    }
    if ($(".toon-4").is(":in-viewport")) {
      $(".toon-4")
        .not(".stop-animation")
        .css("transform", "translate3d(0, " + scrolled * 0.11 + "px, 0)"); // parallax (25% scroll rate)
    }
    $(".toon.stop-animation").css("transform", "translate3d(0, 0, 0)"); // parallax (25% scroll rate)
  }
});
$(document).on("click", "[data-redirect-to]", function(){
  location.href = $(this).data("redirect-to");
});
$(function () {
  $("body").on(
    "click",
    ".inline-review-stars a.bv_main_container",
    function (event) {
      event.preventDefault();
      var reviewId = "#" + $(".product-reviews").attr("id");
      $("body,html").animate({
        scrollTop: $(reviewId).offset().top - 50,
      });
    }
  );

  if ($(window).width() >= 768) {
    $("body").on("click", ".locator_label p a", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $("html, body").animate({
        scrollTop: $("#sec-logo").offset().top - 150,
      });
      return false;
    });
  } else {
    $("body").on("mouseup", ".locator_label p a", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $("html, body").animate({
        scrollTop: $("#sec-logo").offset().top,
      });
      return false;
    });
  }

  $("body").on("click", ".view-coupon", function () {
    window.open(
      "https://cdn.shopify.com/s/files/1/1533/0491/files/coupon.pdf?v=1638450029",
      "_blank"
    );
  });

  $("body").on("click", ".coupon_label p a", function (event) {
    event.preventDefault();
    $(".coupon-popup").show();
    $(".coupon-popup-overlay").show();
    $("body").addClass("overflow");
  });
  $("body").on("click", ".coupon-popup-overlay", function () {
    $(".coupon-popup").hide();
    $(".coupon-popup-overlay").hide();
    $("body").removeClass("overflow");
  });
  $("body").on("click", ".close-pop", function () {
    $(".coupon-popup").hide();
    $(".coupon-popup-overlay").hide();
    $("body").removeClass("overflow");
  });

  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (iOS) {
    $("body").addClass("Ios-true");
  } else {
    //alert("Not IOS");
  }

  if ($("body").hasClass("index")) {
    $("body").addClass("home");
  }
  if ($("body").hasClass("home")) {
    /*$(window).on("load", function(){
    
    setTimeout(function(){
      $(".popup-wrapper").show();
      $("body").addClass("overflow");
    }, 30000);
  });*/
    /*$("body").on("click", ".kl-private-quill-wrapper-Lkqws1 p u", function(){
     $(".popup-wrapper").hide();
     $("body").removeClass("overflow");
  });
  $("body").on("click", ".close-btn", function(){
     $(".popup-wrapper").hide();
     $("body").removeClass("overflow");
  });
  
    $("body").on("click", ".popup-overlay", function(){
     $(".popup-wrapper").hide();
     $("body").removeClass("overflow");
  });*/
    setInterval(function () {
      if (
        $(".popup-main form").length > 0 &&
        $(".popup-main .popup-overlay").length < 1
      ) {
        $("<div class='popup-overlay'></div>").insertBefore(".popup-main form");
        //$('<div class="close-btn">+</div>').prependTo(".popup-main form>div:eq(1)");
        $(".popup-main .close-btn").css({ display: "block" });
      }
    }, 1000);
    setInterval(function () {
      if ($(".popup-main form").length > 0) {
        var w = $(".popup-main form").width();
        var x = $(".popup-main form").offset().left + w;

        var h = $(".popup-main form").height();
        var y = $(".popup-main form").offset().top;

        var y1 = ($(window).height() - $(".popup-main form").height()) / 2;
        $(".popup-main .close-btn").css({
          left: x - 40 + "px",
          top: y1 + 15 + "px",
        });
        if ($(window).width() <= 1024) {
          $(".popup-main .close-btn").css({
            left: x - 40 + "px",
            top: y1 - 330 + "px",
          });
        }
        if ($(window).width() == 768) {
          $(".popup-main .close-btn").css({
            left: x - 40 + "px",
            top: y1 + 10 + "px",
          });
        }
        if ($(window).width() <= 767) {
          $(".popup-main .close-btn").css({
            left: x - 40 + "px",
            top: y1 - 5 + "px",
          });
        }
      }
    }, 1000);
  }

  if($(".product-media-wrapper").length > 0) {
    $(".product-media-wrapper").slick({
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  $("body").on("click keydown", ".product-image-slider-controls span", function () {
    if ($(this).hasClass("slideToPrev")) {
      //$(".product-media-wrapper").slick('slickPrev');
      if ($(this).parent().prev().hasClass("product-grid")) {
        $(".product-grid").slick("slickPrev");
      } else {
        $(this).parent().prev().slick("slickPrev");
      }
    }
    if ($(this).hasClass("slideToNext")) {
      if ($(this).parent().prev().hasClass("product-grid")) {
        $(".product-grid").slick("slickNext");
      } else {
        $(this).parent().prev().slick("slickNext");
      }
    }
  });

  $("body").on("click", ".facet-filters__label img, .hide-filter, .close-filter", function(){
      $('.main-grid-wrap').toggleClass('active');
      $('.hide-filter').toggleClass('active');
      if(!$(".filter-hide").hasClass("active")) {
        $(".facet-filters__label").attr("aria-expanded", "true");
        $("#collectionFilters").attr("aria-hidden", "false");
        $(".collection-sidebar__additional-filter:eq(0) .collection-sidebar__filter-item:eq(0)").focus();
      }
      else {
        $(".facet-filters__label").attr("aria-expanded", "false");
        $("#collectionFilters").attr("aria-hidden", "true");
      }
    });
    $('body').on('keydown', '.facet-filters__label, .hide-filter, .close-filter', function(e){
    if(e.keyCode == 13) {
      $('.main-grid-wrap').toggleClass('active');
      $('.hide-filter').toggleClass('active');
      if(!$(".filter-hide").hasClass("active")) {
        $(".facet-filters__label").attr("aria-expanded", "true");
        $("#collectionFilters").attr("aria-hidden", "false");
        $(".collection-sidebar__additional-filter:eq(0) .collection-sidebar__filter-item:eq(0)").focus();
      }
      else {
        $(".facet-filters__label").attr("aria-expanded", "false");
        $("#collectionFilters").attr("aria-hidden", "true");
      }
    }
  });
  window.addEventListener('keydown', (e) => {
    if (e.key === "Escape") {
        document.activeElement.blur();
      $(".searchResultWrapper").empty();
    };
  });
  $(document).on("focus", "#cart-icon-bubble, #loginBtn", function(){
    $(".searchResultWrapper").empty();
    console.log("unfocus");
  });

  setProductTitle();
  if ($(".product__media-list").length > 0) {
    $(".product__media-list").slick({
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  if ($(".ingredient-wrapper").length > 0) {
    $(".ingredientsTags").each(function () {
      if ($(this).find(".ingredient-list li").length > 0) {
        $(this).find(".ingredient-list li").appendTo($(".ingredient-tag .ingredient-list"));
      }
    });
  }
  var ingCount = 0;
  if ($(".ingredient-wrapper").length > 0) {
    $(".ingredientsTags").each(function () {
      if ($(this).find(".ingredient-list li").length < 1) {
        $(this).css({ display: "none" });
      } else {
        ingCount++;
      }
    });
    if (ingCount == 0) {
      $(".information-tabs").addClass("no-ingredients");
    }
  }

  setProductImageHeight();

  if ($(".logos").length > 0) {
    $(".logos").prepend(
      '<a href="https://shop.hylands.com/" class="hylands-home" target="_blank"><figure><img src="https://cdn.shopify.com/s/files/1/1533/0491/files/Hylands-Logo-TM_1.png?v=1638919002"></figure></a>'
    );

    $(".logos a").attr("target", "_blank");
  }
  $(".logos .hylands-home").click(function (event) {
    event.preventDefault();
    $("html,body").animate(
      {
        scrollTop: $("#shopify-section-email-popup").offset().top,
      },
      "slow"
    );
  });
});

function setProductImageHeight() {
  $(".product__media-list li img").css({ height: "auto" });
  var imgHeight = 100;
  $(".product__media-list li").each(function () {
    var thisHeight = $(this).find("img").height();
    if (thisHeight > imgHeight) {
      imgHeight = thisHeight;
    }
  });
  $(".product__media-list li img").css({ height: imgHeight + "px" });
}

function setProductTitle() {
  if ($(window).width() < 751) {
    $(".productTitleWrap").prependTo(".product.grid");
  } else {
    $(".productTitleWrap").prependTo(".product__info-container");
  }
}

$(window).on("resize", function () {
  setProductTitle();
  setTimeout(function () {
    setProductImageHeight();
  }, 300);
});
$(window).on("load", function () {
  if ($(".kids-slider").length > 0 && $(window).width() < 768) {
    $(".kids-slider > .shg-row").each(function () {
      $(this).slick({
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }

  setInterval(function () {
    if (
      $(".slick-grid").length > 0 &&
      !$(".slick-grid").hasClass("slick-initialized")
    ) {
      $(".slick-grid").slick({
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }, 1000);

  $("body").on("click", ".card-information__wrapper0", function (event) {
    if (!$("body").hasClass("product")) {
      event.preventDefault();
      var vID = $(this).children().children().attr("data-id");
      var vProp = $(this).children().children().attr("data-shipping-property");
      addUpsellProduct(vID, vProp);
    }
  });
  /*$("body").on("click", ".product-recommendations .card-information__wrapper", function(event){ 
    event.preventDefault();
  	var vID = $(this).children().children().attr('data-id');
  	addUpsellProduct(vID);
});*/

  $(document).on("keydown keyup propertychange", ".marquee a, .marquee", function(e){
    $(".marquee a").attr("tabindex", "-1");
    console.log("leave marquee");
  });
  $(document).on("keydown", ".marquee-control, #s-065031e7-57f4-4d7f-9208-7f50c34d815e-btn-wrapper", function(e){
    $(".marquee a").attr("tabindex", "0");
  });
  $(document).on("keydown", ".marquee-control, #s-065031e7-57f4-4d7f-9208-7f50c34d815e-btn-wrapper", function(e){
    $(".marquee a").attr("tabindex", "0");
  });
  $(document).on("keydown", ".card-information__wrapper", function(e){ 
    if(!$("body").hasClass("product")) {
      if(e.keycode == 13) {
        console.log("enter");
        event.preventDefault();
        var vID = $(this).children().children().attr('data-id');
        var vProp = $(this).children().children().attr('data-shipping-property');
        addUpsellProduct(vID, vProp);
      }
    }
  });

  $("body").on("click", ".select-box", function(){
    $('.select-wrapper').toggleClass("active");
    if($(this).children(".sel-text").attr("aria-expanded") == "true") {
    	 $(this).children(".sel-text").attr("aria-expanded", "false");
    }
    else {
       $(this).children(".sel-text").attr("aria-expanded", "true");
    }
  }); 
  $(document).on("focus", ".select-box", function(){
      $(this).children(".sel-text").attr("aria-expanded", "true");
  });
  $(document).on("focusout", ".select-box", function(){
      $(this).children(".sel-text").attr("aria-expanded", "false");
  });
  $("body").on("mouseleave", ".select-box", function(){
    $('.select-wrapper').removeClass("active");
    $(this).children(".sel-text").attr("aria-expanded", "false");
  });

  function customSort(sortValue) {
    let collectionUrl =
      $(".filter-wrapper").data("collection-url") + "/?sort_by=" + sortValue;
    //console.log(collectionUrl);

    $.get({
      url: collectionUrl,
      success: function (data) {
        var newProductsWrapper = $(data).find("#product-grid");
        var newProductsHtml = newProductsWrapper.html();
        $("#product-grid").html(newProductsHtml);

        var newItemCount = newProductsWrapper.attr("data-products-count");
        $(".js-product-grid__count").text(newItemCount);
        history.pushState(
          {
            page: collectionUrl,
          },
          null,
          collectionUrl
        );

        $("#product-grid").removeClass("ajax-loading");
      },
    });
  }

  $("body").on("click", ".custom-select li", function () {
    var selected = $(this).children().text();
    var selected_val = $(this).data("value");

    $(".sel-text").text(selected);
    customSort(selected_val);
    //$('#SortBy').val(selected_val);

    //var elem = document.getElementById('SortBy');
    //elem.dispatchEvent(new Event("change"));
  });

  $("body").on("click", ".custom-select.in-blog li", function () {
    var selected = $(this).children().text();
    var selected_val = $(this).data("value");

    $(".sel-text").text(selected);
    $("#BlogTagFilter").val(selected_val);

    var elem = document.getElementById("BlogTagFilter");
    elem.dispatchEvent(new Event("change"));
  });
  $("body").on("keydown", ".custom-select.in-blog li", function(event){
    if(event.keyCode == 13) {
  	var selected = $(this).children().text();
    	var selected_val = $(this).data('value');
  
    $('.sel-text').text(selected);
  	$('#BlogTagFilter').val(selected_val);
    	
  	var elem = document.getElementById('BlogTagFilter');
       elem.dispatchEvent(new Event("change"));
    }
  });
  /*I am new Badge*/
  $(window).on("load", ".new-badge h3 a", function () {
    var href = $(this).attr("href");
    //console.log(href);
  });

  /*$(".customfield-tabs .tab-info-wrap p a").click(function () {
    window.open(
      "https://cdn.shopify.com/s/files/1/1533/0491/files/HKIEO---G48_Lot_21253.pdf?v=1644880366",
      "name",
      "width=1000,height=1000"
    );
    return false;
  });*/
});

$(window).on("load", function () {
  $('<a href="/account">Customer Login</a>').appendTo(
    ".header__icon .account-list li:nth-child(1)"
  );
  $('<a href="/tools/recurring/login">Subscriptions</a>').appendTo(
    ".header__icon .account-list li:nth-child(2)"
  );
  $('<a href="/pages/loyalty-program">Wellness Rewards</a>').appendTo(
    ".header__icon .account-list li:nth-child(3)"
  );

  if($("#insta-feed").length > 0) {
    let instaFeed = setInterval(function(){
      if($(".instafeed-container").length > 0) {
        $("#insta-feed a").each(function(){
          $(this).attr("tabindex", "0");
        });
        clearInterval(instaFeed);
      }
    }, 1000);
  }
});

$("body").on("mouseenter focus", ".header__icons .my-account-icon", function(){
	$(this).children(".account-list").addClass("active");
  $(this).attr("aria-expanded", "true");
});

$("body").on("mouseleave focusout", ".header__icons .my-account-icon", function(){
	$(this).children(".account-list").removeClass("active");
  $(this).attr("aria-expanded", "false");
});

$(document).on("mouseenter focus", ".header__inline-menu>ul>li", function(){
  console.log("Menu on focus");
  $(".child-column-2").parent().parent(".dropdown-menu-wrapper").addClass("child-col-2"),
  $(".child-column-0").parent().parent(".dropdown-menu-wrapper").addClass("child-col-0"),
  $(".child-column-0.two-child").parent().parent(".dropdown-menu-wrapper").addClass("child-col-2-gc"),
  $(".child-column-3").parent().parent(".dropdown-menu-wrapper").addClass("child-col-3"),
  $(".list-menu li").each(function () {
      $(this).find(".sub-menu-label").prependTo($(this).find(".menu-child-wrap"));
  });
  if(!$(this).hasClass("open")) {
  	$(this).addClass("open");
    $(this).attr("aria-expanded", "true");
  }
});
$(document).on("mouseleave focusout", ".header__inline-menu>ul>li", function(){
  $(this).removeClass("open");
  $(this).attr("aria-expanded", "false");
});

/*** arrow navigation ***/

/*MAIN MENU*/
var containerDiv = document.getElementById("site-header");
var anchorTags = containerDiv.querySelectorAll("a");

containerDiv.addEventListener("keydown", function(event) {
  //var currentIndex = anchorTags.indexOf(document.activeElement);
  var currentIndex = Array.prototype.indexOf.call(anchorTags, document.activeElement);
  console.log(event.keyCode);
  if (event.keyCode === 37 || event.keyCode === 38) { // left or up arrow key
    if (currentIndex > 0) {
      console.log(currentIndex - 1);
      if(currentIndex == 72) {
        currentIndex = currentIndex - ($("#nav-Shop a").length - 1);
      }
      anchorTags[currentIndex - 1].focus();
    }
  } else if (event.keyCode === 39 || event.keyCode === 40) { // right or down arrow key
    if (currentIndex < anchorTags.length - 1) {
      anchorTags[currentIndex + 1].focus();
      console.log(currentIndex + 1);
    }
  }
  //event.preventDefault();
});
/*END MAIN MENU*/

/*COLLECTION FILTERS*/
$(document).on("keydown", ".facet-filters__label", function(event){
  if(event.keyCode === 39) { // right arrow key
    $(this).next().next(".select-box").focus();
  }
});
$(document).on("keydown", ".select-box", function(event){
  if(event.keyCode === 37) { // left arrow key
    console.log(event.keyCode);
    console.log(event.target);
    $(this).prev().prev(".facet-filters__label").focus();
  }
});
/*END COLLECTION FILTERS*/

/*BLOG FILTERS */

var containerDiv = document.getElementById("menu-div-custom");
if(containerDiv) {
var anchorTags = containerDiv.querySelectorAll("a");

containerDiv.addEventListener("keydown", function(event) {
  //var currentIndex = anchorTags.indexOf(document.activeElement);
  var currentIndex = Array.prototype.indexOf.call(anchorTags, document.activeElement);
  console.log(event.keyCode);
  if (event.keyCode === 37 || event.keyCode === 38) { // left or up arrow key
    if (currentIndex > 0) {
      anchorTags[currentIndex - 1].focus();
    }
  } else if (event.keyCode === 39 || event.keyCode === 40) { // right or down arrow key
    if (currentIndex < anchorTags.length - 1) {
      anchorTags[currentIndex + 1].focus();
    }
  }
  //event.preventDefault();
});
}
/*END BLOG FILTERS*/

/*PDP Tabs*/

$(document).on("keydown", "#info-tabsWrapper li, .tags-boxes .tag-box, .logos a, .yotpo-pager a", function(event){
  if(event.keyCode === 37) {
    $(this).prev().focus();
  } else if(event.keyCode === 39) {
    $(this).next().focus();
  }
});

/*END PDP Tabs*/

function navigateByArrow(container, selector) {
  let containerDiv2 = document.getElementById(container);
  if(containerDiv2) {
  let anchorTags2 = containerDiv2.querySelectorAll(selector);
  containerDiv2.addEventListener("keydown", function(event) {
    let currentIndex2 = Array.prototype.indexOf.call(anchorTags2, document.activeElement);
    console.log(event.keyCode);
    if (event.keyCode === 37 || event.keyCode === 38) { // left or up arrow key
      if (currentIndex2 > 0) {
        anchorTags2[currentIndex2 - 1].focus();
        console.log(anchorTags2[currentIndex2 - 1]);
      }
    } else if (event.keyCode === 39 || event.keyCode === 40) { // right or down arrow key
      if (currentIndex2 < anchorTags2.length - 1) {
        anchorTags2[currentIndex2 + 1].focus();
        console.log(anchorTags2[currentIndex2 + 1]); 
      }
    }
  });
  }
}
navigateByArrow("MainContent", "a");
navigateByArrow("site-footer", "a");
navigateByArrow("info-tabsWrapper", "li");
/*** end arrow navigation ***/
$(document).on("click", ".see-all a", function (event) {
  event.preventDefault();
  $(".grid__item").removeClass("grid-inactive");
  $(".see-all").css({ display: "none" });
});
var searchVal = "";
$("body").on("keyup", ".search-enabled .search-modal form", function () {
  searchVal = $(
    ".search-enabled .search-modal .search__input.field__input"
  ).val();
  if (searchVal == "") {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. 'pain relief'"
    );
  } else {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. " + searchVal
    );
  }
});
$("body").on("focusin", ".search-enabled .search-modal form", function () {
  $(".search-enabled .search-modal .search__input.field__input").val(searchVal);
  if (searchVal == "") {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. 'pain relief'"
    );
  } else {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. " + searchVal
    );
  }
});
$("body").on("focusout", ".search-enabled .search-modal form", function () {
  $(".search-enabled .search-modal .search__input.field__input").val("");
  if (searchVal == "") {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. 'pain relief'"
    );
  } else {
    $(".search-enabled .search-modal .field__label").text(
      "I'm looking for.. " + searchVal
    );
  }
});

$("body").on("keyup focus", ".header__search .search__input", function () {
  if ($.trim($(this).val()) != "") {
    var searchTerm = $(this).val();
    $(".searchResultWrapper h2#predictive-search-products svg").show();
    $(".searchResultWrapper .predictive-search__loading-state").show();
    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent(
        "resources[limit]"
      )}=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          //this.close();
          throw error;
        }
        //console.log(response.text());
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        //this.cachedResults[queryKey] = resultsMarkup;
        //this.renderSearchResults(resultsMarkup);
        //console.log(resultsMarkup);
        $(".searchResultWrapper").html(resultsMarkup);
        $(".searchResultWrapper h2#predictive-search-products svg").hide();
        $(".searchResultWrapper .predictive-search__loading-state").hide();
      })
      .catch((error) => {
        //this.close();
        throw error;
      });
  }
});
$("body").on("click", function (event) {
  if (!$(event.target).closest(".header__search").length) {
    $(".searchResultWrapper").empty();
    $(".header__search .search__input").val("");
    $(".header__search .search__input").css({ width: "18px", opacity: "0" });
    //console.log("focusout");
  }
});
$("body").on("focusout", ".header__search .search__input", function () {});
$("body").on("click", ".field__button", function (event) {
  if ($.trim($(".header__search .search__input").val()) == "") {
    event.preventDefault();
    //$(".header__search .search__input").stop().toggleClass("active");
    if ($(".header__search .search__input").width() > 100) {
      $(".header__search .search__input").css({ width: "18px", opacity: "0" });
    } else {
      $(".header__search .search__input").css({ width: "183px", opacity: "1" });
      $(".header__search .search__input").focus();
    }
  }
});

$("body").on(
  "change",
  ".rc-radio-group__options input[type='radio']",
  function () {
    if ($(this).is(":checked")) {
      //$(".rc-radio").removeClass("rc_widget__option--active rc-option--active");
      //$(this).parent(".rc-radio").addClass("rc_widget__option--active rc-option--active");
      if ($(this).val() == "subsave") {
        $(".otButton").css({ display: "none" });
        $(".addSubscription").css({ display: "block" });
      } else {
        $(".addSubscription").css({ display: "none" });
        $(".otButton").css({ display: "block" });
      }
    }
  }
);

$("body").on("click", ".addSubscription", function (event) {
  event.preventDefault();
  event.stopPropagation();
  var _this = $(this);
  var variant_id = $(".product-form form input[name='id']").val();
  var qty = $(".product-form__quantity input[name='quantity']").val();
  var unit_type = "";
  var isSubs = false;
  $(".rc_container .rc-radio-group__options label").each(function () {
    if ($(this).children("input[type='radio']").is(":checked")) {
      var subs_type = $(this).children("input[type='radio']").val();
      if (subs_type != "onetime") {
        isSubs = true;
      }
    }
  });
  if (isSubs) {
    _this.addClass("loading");
    _this.children().removeClass("hidden");
    var frequency = $(".rc_container select[name='selling_plan']").val();
    frequency = $.trim(
      $(
        ".rc_container select[name='selling_plan'] option[value='" +
          frequency +
          "']"
      ).attr("data-plan-option")
    );
    var fu = frequency.split(" ");

    var selling_plan = $(".rc_container select[name='selling_plan']").val();

    var data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan,
      properties: {
        "Selling Plan": frequency,
      },
    };
    //console.log(data);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        _this.removeClass("loading");
        _this.children(".loading-overlay__spinner").addClass("hidden");
      },
    });
  }
});

$("body").on("click", ".otButton", function (event) {
  event.preventDefault();
  var _this = $(this);
  var variant_id = $(".product-form form input[name='id']").val();
  var qty = $(".product-form__quantity input[name='quantity']").val();
  _this.addClass("loading");
  _this.children().removeClass("hidden");
  var data = {
    id: variant_id,
    quantity: qty,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      _this.removeClass("loading");
      _this.children(".loading-overlay__spinner").addClass("hidden");
    },
    error: function (data) {
      console.log(data);

      var element_id = data.responseJSON.description;
      var number = element_id.match(/\d+/);

      // add custom code
      _this.removeClass("loading");
      _this.children(".loading-overlay__spinner").addClass("hidden");
      alert(
        "You are trying to add more units then the available quantity (" +
          number +
          "), Please reduce the quantity and try again."
      );
    },
  });
});

$("body").on("click", ".locator_label p a", function (event) {
  event.preventDefault();
});

$(window).on("load", function () {
  setTimeout(function () {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("promo") == "cnc") {
      //console.log("found");
      /*$("html, body").animate({
          scrollTop: $(".logo-list").offset().top - 150
        }, 300);*/
      $(".coupon-popup").show();
      $(".coupon-popup-overlay").show();
      $("body").addClass("overflow");
    }
  }, 1000);
});

/****************************/
$(window).on("load", function () {
  if ($(".logos").length > 0) {
    $(".logos a").attr("target", "_blank");
  }

  var ptext = $(".logo-list-wrapper p").text();

  $(".logo-list-wrapper h2 span").append(ptext);
});

if ($(".yotpo-custom").length > 0) {
  $("body").addClass("yotpo-custom");
}

/*Yotpo app*/
if ($(window).width() >= 769) {
  $("body").on(
    "mousedown",
    "div[aria-label='FreeTextCampaign'] .yotpo-campaign-switcher-wrapper",
    function () {
      console.log("clicked");
      $("html, body").animate(
        {
          scrollTop: $(".yotpo-widget-referral-widget").offset().top - 100,
        },
        500
      );
    }
  );
} else {
  $("body").on(
    "mousedown",
    "div[aria-label='FreeTextCampaign'] .yotpo-campaign-switcher-wrapper",
    function () {
      console.log("clicked");
      $("html, body").animate(
        {
          scrollTop: $(".yotpo-widget-referral-widget").offset().top + 400,
        },
        500
      );
    }
  );
}

$(window).on("load", function () {
  if ($(".product-section").length > 0) {
    /*if($(".locator_label").length > 0) {
  		var locator_label = $(".locator_label").html();
  		$('<div class="locator_label">' + locator_label + '</div>').appendTo(".inline-review-stars");
    }*/

    $(".formWrapper").next(".locator_label").css("display", "none");

    var currentPrice = $(".rewards_points").children(".current-price").text();
    var round_num = Math.round(currentPrice);

    $(".rewards_points p .num_ber").append(round_num);
  }
});

/*$("body").on("click", ".ibtn", function(){
  $(".rewards_popup").show();
});*/

$(".ibtn").click(function (e) {
  e.preventDefault();
  $(".rewards_popup").fadeToggle("slow");
});

$(document).on("click", function (event) {
  if (!$(event.target).closest(".rewards_points").length) {
    $(".rewards_popup").fadeOut("slow");
  }
});

$("body").on("click", ".product-form__input > label", function () {
  var attr_value = $(this).prev().attr("value").toUpperCase();

  $(".product__media-list .productMdiaItemMain").each(function () {
    var img_alt = $(this).find("img").attr("alt").toUpperCase();

    if (attr_value == img_alt) {
      $(".product-single__media-group .product-single__media-wrapper").addClass(
        "slick-current slick-active"
      );
      $(this).removeClass("slick-current slick-active");
    }
  });
});

/*PDP new Design*/

if ($(".ingredient-wrapper").length > 0) {
  $("body").on("click", ".ingredient-wrapper .text-wrap h3", function () {
    $(this).next(".tag-text").slideToggle();
    $(this).parent(".text-wrap").toggleClass("active");
  });
  $(document).on('keydown', '.ingredient-wrapper .text-wrap h3', function(e) {
    if(e.keyCode === 13) {
      $(this).trigger("click");
    }
  });
}

if ($(".faq-accordion").length > 0) {
  $("body").on("click", ".acc-wrapper ul li h3", function () {
    $(this).next(".faq-answer").slideToggle();
    $(this).parent().toggleClass("active");
  });
}

$(function () {
  if ($(".product-section").length > 0) {
    if ($(".locator_label").length > 0) {
      var locator_label = $(".locator_label").html();
      $('<div class="locator_label">' + locator_label + "</div>").appendTo(
        ".inline-review-stars"
      );
    }
  }

  $(
    ".swatch-main .shg-box-content .shg-c:nth-child(2) .shg-row .shg-c-lg-4"
  ).appendTo(".swatch-main .shg-box-content .shg-c:nth-child(1) .shg-row");
  $(
    ".swatch-main .shg-box-content .shg-c:nth-child(3) .shg-row .shg-c-lg-4"
  ).appendTo(".swatch-main .shg-box-content .shg-c:nth-child(1) .shg-row");
});

/*$("body").on("mouseenter", ".swatch-main .shg-row .shg-c-lg-4", function(event){
   var hov_index = ($(this).index());
  $(".custom-slick .shg-sld-slides .shg-sld-item").removeClass("shg-sld-active");
  $(".custom-slick .shg-sld-slides .shg-sld-item:eq("+hov_index+")").addClass("shg-sld-active");
   
});*/
$(document).on(
  "click",
  ".descriptionWrap a[href='#'], .tab-info-wrap a[href='#'], .tag-text a[href='#']",
  function (event) {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".footer-center-text").offset().top,
      },
      1000
    );
  }
);

$(window).on("load", function () {
  var x = setInterval(function () {
    if ($("#dynamic-react-root").length > 0) {
      //$("#dynamic-react-root").next("div").wrapAll("<div class='new-popup'></div>");
      clearInterval(x);
    }
  }, 1000);

  var z = setInterval(function () {
    if ($("[data-testid='klaviyo-form-WxY32S'] > div").length == 1) {
      $("[data-testid='klaviyo-form-WxY32S']").addClass("success");
      clearInterval(z);
    }
  }, 1000);
});

mobileOnlySlider(
  ".parallax-page-collection .collection slider-component ul",
  false,
  false,
  766
);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    speed: 500,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
} // Mobile Only Slider

/********* search filter **************/

function searchsort(sortValue) {
  let collectionUrl = location.href + "&sort_by=" + sortValue;

  $.get({
    url: collectionUrl,
    success: function (data) {
      var newProductsWrapper = $(data).find(
        ".template-search__results #product-grid"
      );
      var newProductsHtml = newProductsWrapper.html();
      $(".template-search__results #product-grid").html(newProductsHtml);

      var newItemCount = newProductsWrapper.attr("data-products-count");
      $(".js-product-grid__count").text(newItemCount);
      history.pushState(
        {
          page: collectionUrl,
        },
        null,
        collectionUrl
      );

      $(".template-search__results #product-grid").removeClass("ajax-loading");
    },
  });
}

$("body").on("click", ".custom-select li", function () {
  var selected = $(this).children().text();
  var selected_val = $(this).data("value");

  $(".sel-text").text(selected);
  searchsort(selected_val);
  //$('#SortBy').val(selected_val);

  //var elem = document.getElementById('SortBy');
  //elem.dispatchEvent(new Event("change"));
});




/* Other JS */

$(function(){

if($(".skincare-landing-slider .shg-sld-slides").length > 0) {
  $(".skincare-landing-slider .dog-slider.babyskinslider .shg-sld-slides").slick({
    infinite: false,
    dots: true, 
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
  /*$(".child-column-2").parent().parent(".dropdown-menu-wrapper").addClass("child-col-2");
  $(".child-column-0").parent().parent(".dropdown-menu-wrapper").addClass("child-col-0");
  $(".child-column-0.two-child").parent().parent(".dropdown-menu-wrapper").addClass("child-col-2-gc");
  $(".child-column-3").parent().parent(".dropdown-menu-wrapper").addClass("child-col-3");
  $('.list-menu li').each(function(){
    $(this).find(".sub-menu-label").prependTo($(this).find(".menu-child-wrap"));
  });*/
  
  if($(".dog-slider .shg-sld-slides").length > 0) {
    $(".dog-slider .shg-sld-slides").on("init", function(event, slick){
      $(".dog-slider .shg-sld-dots").css({"display":"none"});
    });
    $(".dog-slider .shg-sld-slides img").each(function(){
      $(this).attr("src", $(this).data("src"));
    });
    $(".dog-slider .shg-sld-slides").slick({
      infinite: false,
      dots: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
});
$(document).on("click", ".quick-selecter button", function () {
      var q_qty = parseInt($(this).parent('.quick-selecter').find('#qty_input').val());
    console.log(q_qty);
      if($(this).hasClass('plus')) {
        q_qty++;
      }else {
        if(q_qty > 1) {
          q_qty--;
        }
      }
      q_qty = (isNaN(q_qty))?1:q_qty;
      $(this).parent('.quick-selecter').find('#qty_input').val(q_qty);
});

$(document).ready(function() {
  setTimeout(function(){
      $("body div:last-child").addClass('display-hide');
  }, 6000);
}); 


$("body").on("mouseenter", ".skincare-product-card", function(){
    $(this).addClass("active-bg-img");
}).on("mouseleave", ".skincare-product-card", function(){
    $(this).removeClass("active-bg-img");
});

$(document).on("click", ".promo-title a", function(e){
  e.preventDefault();
  $(".dogs_popup").addClass("active");
});